import React from 'react';
import { AiNameGeneratorWidgetContentfulModel } from 'src/api/models/AiNameGeneratorWidget';
import AIGeneratorWidgetHandler from 'src/organisms/Standard/SEOPage/ContentHandlers/AIGeneratorWidgetHandler';

const getDynamicAiNameGeneratorWidget = (props: AiNameGeneratorWidgetContentfulModel): JSX.Element => (
  <AIGeneratorWidgetHandler {...props} />
);

export default getDynamicAiNameGeneratorWidget;
